export default function () {
    const $config = useRuntimeConfig().public;

    function buildReactiveHead(event, error) {
        watch(
            event,
            () => {
                buildHead(event.value, error.value);
            },
            {immediate: true},
        );
    }

    function buildHead(event, error) {
        if (event === null && !error) return useSeo().buildHeadLoading();
        if (!event) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            image: $config.images + event.event_image,
            title: `${event.event_title} | ${$config.siteName}`,
            description: stripTags(event.event_excerpt),
            index: true,
        });
    }

    function stripTags(html) {
        return html.replace(/(<([^>]+)>)/gi, ' ');
    }

    return {buildReactiveHead};
}
